import type { TExportEventType } from "constants/index";
import type { CatalogTreeSystem } from "./catalog-items-hierarchy";

export function designScopeCatalogExportEventType(
  format: "CSV" | "EXCEL" | "PDF",
  view: "list" | "hierarchy",
  treeSystem: CatalogTreeSystem
): TExportEventType {
  if (view === "list") {
    if (format === "CSV") return "DESIGN_SCOPE_CATALOG_EXPORT_CSV";
    if (format === "PDF") return "DESIGN_SCOPE_CATALOG_LIST_EXPORT_PDF";
    return "DESIGN_SCOPE_CATALOG_LIST_EXPORT_EXCEL";
  }
  if (treeSystem === "MF") {
    return format === "PDF"
      ? "DESIGN_SCOPE_CATALOG_MASTERFORMAT_EXPORT_PDF"
      : "DESIGN_SCOPE_CATALOG_MASTERFORMAT_EXPORT_EXCEL";
  }
  return format === "PDF"
    ? "DESIGN_SCOPE_CATALOG_UNIFORMAT_EXPORT_PDF"
    : "DESIGN_SCOPE_CATALOG_UNIFORMAT_EXPORT_EXCEL";
}

export function designScopeCatalogHierarchyExportEventType(
  format: "EXCEL" | "PDF",
  treeSystem: CatalogTreeSystem
): TExportEventType {
  return designScopeCatalogExportEventType(format, "hierarchy", treeSystem);
}

/** Base name, without extension, used as the print-window title and PDF audit name. */
export function designScopeCatalogPdfFileBaseName(
  catalogName: string | undefined
): string {
  const safe =
    (catalogName || "Catalog")
      .replace(/[\\/:*?"<>|]/g, " ")
      .replace(/\s+/g, " ")
      .trim() || "Catalog";
  return `Design_Scope_Catalog_${safe}`;
}
